// extracted by mini-css-extract-plugin
export default {"prevArrow":"page_prevArrow__1C+J1","nextArrow":"page_nextArrow__dVh9X"};